import { apiGet } from '@/shared/utils/requestBuilder';
import { throwApiError } from '@/shared/utils/apiResponse';
import type { ConsultarOrigemInput, OrigemPedidoResultado } from '../../types/origemPedidoTypes';
import { parseAndamentosProcesso, parseListaPendencias } from '../services';
import { parseAndamentoExato } from '@/features/arbitro/utils';

export const origemPedidoService = {
  consultar: async ({
    processoId,
    origem,
    page,
    perfil,
  }: ConsultarOrigemInput): Promise<OrigemPedidoResultado> => {
    if (perfil === 'ARBITRO' && origem.tipo !== 'ANDAMENTO')
      throw new Error('Origem indisponível para este acesso');
    const base =
      perfil === 'ARBITRO'
        ? `/arbitral/painel/processos/${processoId}`
        : `/admin/arbitral/processos/${processoId}`;
    const limit = 20;
    const response =
      origem.tipo === 'ANDAMENTO'
        ? await apiGet(`${base}/andamentos/${origem.id}`)
        : await apiGet(`${base}/pendencias`, {
            filtro: 'todas',
            page,
            limit,
            [origem.tipo === 'GRUPO_PENDENCIA' ? 'grupoCriacaoId' : 'pendenciaId']: origem.id,
          });
    if (!response.ok) await throwApiError(response, 'Não foi possível abrir a origem do pedido');
    const result = await response.json();
    if (perfil === 'ARBITRO')
      return { tipo: 'RESPOSTA', andamento: parseAndamentoExato(result.data) };
    if (origem.tipo === 'ANDAMENTO') {
      const [andamento] = parseAndamentosProcesso([result.data]);
      if (!andamento) throw new Error('Evento indisponível para este acesso');
      return { tipo: 'ANDAMENTO', andamento };
    }
    const data = parseListaPendencias(result);
    return { tipo: origem.tipo, items: data.items, total: data.total, page, limit };
  },
};
